import getIn from '@alexaivars/get-in';
import { NAME } from './constants';
import { TOAST_ADD, TOAST_REMOVE, TOAST_REMOVE_ALL } from './actions';

const toasters = (state = [], action = {}) => {
  switch (action.type) {
    case TOAST_ADD:
      return state.concat(action.payload);
    case TOAST_REMOVE:
      return state.filter(m => m !== action.payload);
    case TOAST_REMOVE_ALL:
      return [];
    default:
      return state;
  }
};

export const getToasts = state => getIn(state, [NAME], []);
export default toasters;
